const HeroBanner = () => {
  return (
    <section className="relative pt-32 pb-20 bg-gradient-to-r from-[#D4693A] to-[#FFF8F0] overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-32 h-32">
          <i className="ri-truck-line text-[#2A2A2A] text-9xl"></i>
        </div>
        <div className="absolute bottom-20 right-40 w-32 h-32">
          <i className="ri-truck-line text-[#2A2A2A] text-9xl"></i>
        </div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center mb-6">
          <a href="/" className="text-[#6B6B6B] text-sm hover:text-[#FF8C42] transition-colors cursor-pointer">
            Home
          </a>
          <i className="ri-arrow-right-s-line text-[#6B6B6B] mx-2"></i>
          <span className="text-[#FF8C42] text-sm font-semibold">Privacy Policy</span>
        </div>
        
        <h1 className="text-5xl md:text-7xl font-bold text-[#2A2A2A] mb-4">
          Privacy Policy
        </h1>
        <p className="text-lg text-[#6B6B6B]">
          Last Updated: January 1, 2024
        </p>
      </div>
    </section>
  );
};

export default HeroBanner;